import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class LogoutComponent implements OnInit {

  constructor(private authService: AuthService) {
  }

  logout() {
    this.authService.logout();
  }

  ngOnInit() {
    return;
  }

}
